module.exports = __webpack_public_path__ + "img/g1.e4236ff2.jpg";